import { render } from "./OuterList.vue?vue&type=template&id=2fa5a2fa&ts=true"
import script from "./OuterList.vue?vue&type=script&lang=ts"
export * from "./OuterList.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__